import { atom } from "recoil";

export const needsReviewUpdatedFlagState = atom<boolean>({
  key: "needsReviewUpdatedFlagState",
  default: false,
});
